import {Component, Input} from '@angular/core';
import {getProfitClass} from 'src/app/shared/utils/helper';

export interface TotalProfitData {
  profit?: number;
  customer?: number;
  commission?: number;
  swap?: number;

  feePayout?: number;
  ib?: number;
  bonus?: number;
  wallet?: number;

  netProfit?: number;

  date?: number;
}

@Component({
  selector: 'fx-total-profit',
  templateUrl: './total-profit.component.html',
  styleUrls: ['./total-profit.component.sass'],
})
export class TotalProfitComponent {
  @Input() data: TotalProfitData;
  @Input() class: string;
  @Input() uppercase: boolean;
  @Input() timeago: number;
  @Input() caption: string;
  @Input() customTitle: boolean;
  @Input() currency: string;
  getProfitClass = getProfitClass;
}
